<div>
  <a
    class="nav-item"
    [routerLink]="RouteLocations.Dashboard.absoluteUrl"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <img class="inline-block me-2" ngSrc="/assets/images/icons/home-icon.webp" height="30" width="30" [priority]="true">
    Dashboard
  </a>
  <a
    class="nav-item"
    [routerLink]="RouteLocations.Dashboard.children.Campaigns.absoluteUrl"
    routerLinkActive="active"
  >
    <img class="inline-block me-2" ngSrc="/assets/images/icons/campaign-icon.webp" height="30" width="30" [priority]="true">
    Campaigns
  </a>

  @for (entityTypeDetails of GameEntityTypeDetails; track entityTypeDetails.type) {
    <a
      class="nav-item"
      [routerLink]="RouteLocations.Dashboard.children.GameEntities.children.GameEntityList.absoluteUrl"
      [queryParams]="getQueryParamsForType(entityTypeDetails.type)"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <app-game-entity-type-icon [type]="entityTypeDetails.type" [height]="30" [width]="30" [priority]="true" class="me-2" />
      {{ entityTypeDetails.plural }}
    </a>
  }
</div>
